import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { observable, isObservable, toJS } from 'mobx'
import CollectionContext from './contexts/CollectionContext'
import useValue from '../hooks/use-value'

function ValueToCollection (props) {
  const collectionRef = React.useRef(observable.array())
  const collection = collectionRef.current

  const value = useValue(props.name, props.defaultValue)

  React.useEffect(() => {
    let newValue = value

    if (!newValue || newValue.length < 1) {
      newValue = []
    }

    collection.replace(newValue.map(collectionEntry => {
      if (!isObservable(collectionEntry)) {
        collectionEntry = observable.map(Object.entries(collectionEntry))
      }

      return collectionEntry
    }))
  }, [value])

  return (
    <CollectionContext.Provider value={collection}>
      {props.children}
    </CollectionContext.Provider>
  )
}

ValueToCollection.defaultProps = {
  defaultValue: null
}

ValueToCollection.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any
}

export default observer(ValueToCollection)
